import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import SearchDropdownFilter from "./SearchDropdownFilter";
import Merchant from "../../../model/merchant/Merchant";

class MerchantFilter extends SearchDropdownFilter<Merchant> {

	itemToId(item: Merchant): string {
		return item.id;
	}

	itemToLabel(item: Merchant): string {
		return item.name;
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.merchant.merchants
	}
}

export default connect(mapStateToProps)(MerchantFilter)